import { useState, useEffect } from 'react';
import { getCutoffTime } from 'utils/deliveryDates';

// Re-check on an interval, not just on mount/date-change — a tab left open
// across the cutoff would otherwise keep showing stale (unlocked) status.
const RECHECK_INTERVAL_MS = 60 * 1000;

export const useLockStatus = (selectedDeliveryDate) => {
    const [isLocked, setIsLocked] = useState(false);

    useEffect(() => {
        const checkLockStatus = () => {
            if (!selectedDeliveryDate) {
                setIsLocked(false);
                return;
            }
            const now = new Date();
            const lockDate = getCutoffTime(selectedDeliveryDate);
            if (!lockDate) {
                setIsLocked(false);
                return;
            }
            const shouldLock = now >= new Date(lockDate.getTime() + 1000 * 60 * 20); // leniency 20 minutes
            setIsLocked(shouldLock);
        };

        checkLockStatus();
        const intervalId = setInterval(checkLockStatus, RECHECK_INTERVAL_MS);
        return () => clearInterval(intervalId);
    }, [selectedDeliveryDate]);

    return isLocked;
};
